"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        display: 'flex',
        alignItems: 'center',
        padding: `${theme_1.Spacing.small}px 0px ${theme_1.Spacing.small}px ${theme_1.Spacing.medium}px`,
        borderBottom: `1px solid ${design_system_1.Colors.grey300}`,
    },
    iconWrapper: {
        marginRight: theme_1.Spacing.small,
    },
});
function FloatingMenuAlert({ heading, message }) {
    return (common_utils_1.isolateComponent("div", { css: Styles.root },
        common_utils_1.isolateComponent("div", { css: Styles.iconWrapper },
            common_utils_1.isolateComponent(design_system_1.Icon, { color: "red500", name: "alertTriangle", size: 22 })),
        common_utils_1.isolateComponent("div", null,
            common_utils_1.isolateComponent(design_system_1.Text, { fontWeight: 700, type: "altText900" }, heading),
            common_utils_1.isolateComponent("br", null),
            common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText900" }, message))));
}
exports.default = FloatingMenuAlert;
